/** Pendant zu `EnumExtension.GetEnumDisplayNames` — Auswahlliste aus einer Enum-Tabelle. */

/**
 * Strukturgleich zu `SelectOption` aus `src/components/ui/types.ts` (REQ-00 §13);
 * hier eigenständig definiert, damit `src/utils` nicht von `src/components` abhängt.
 */
export interface EnumOption<TValue extends number> {
  value: TValue;
  text: string;
}

/**
 * Liefert die Einträge in aufsteigender Wertreihenfolge — genau wie `Enum.GetValues`,
 * das nach dem Binärwert der Konstanten sortiert.
 */
export function getEnumOptions<T extends number>(displayNames: Record<T, string>): EnumOption<T>[] {
  return Object.keys(displayNames)
    .map((key) => Number(key) as T)
    .map((value) => ({ value, text: displayNames[value] }));
}
